<template>
  <section class="video-container">
    <video autoplay playsinline loop class="video">
      <source :src="videoBg">
    </video>
    <v-img :src="imgtop" class="video-content">
      <div class="text-center text-h1 white--text">
      </div>
    </v-img>
  </section>
</template>

<script>
export default {
  name: 'test',
  props: {},
  data() {
    return {
      imgBottom: 'https://admin.test05.superlinda.nl/images/m4qyt529guvhmdwk.png',
      // imgTop: 'https://images.superlinda.nl/images/a3hxfv6aa_1723_hlyvx6cc.png',
      imgtop: 'https://admin.test05.superlinda.nl/images/3qvzjy6n3a9ch5ze.png',
      videoBg: 'https://luysterburgbv.nl/app/uploads/2021/03/Vers-van-het-Land.mp4',
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.video-container {
  position: relative;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  width: 100vw;
  height: 60vh;
}
.video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}
.video-content {
  position: absolute;
  top: 70%;
  left: 10%;
  transform: translate(-10%, -70%);
  width: 30%;
  height: auto;
  opacity: 1;
}
</style>
